<app-grid
[columns]="columns"
[rows]="data.tableRows"
[tableParams]="data.tableParams"
[multiSelect]="false"
[gridName]="gridName"
[allowCopy]="true"
(copyClicked)="copyExamClicked($event)"
(refreshDataFromServer)="refreshData($event)"
(rowSelected)="setExamData($event)"
(viewAllClicked)="veiwAllExamData($event)"
(addClicked)="addExamClicked()"
(editClicked)="editExamClicked($event)"
(deleteClicked)="deleteExamClicked()"
(exportClicked)="exportExamClicked()"
(selectAllClicked)="selectAllExamClicked()"
></app-grid>

<!-- <app-examination (examSelected)="setExam($event)"></app-examination> -->